/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-vars */
/* eslint-disable import/prefer-default-export */
import { CANNABIS_SKILLS, CANNABIS_EMPLOYEE_IDS, CANNABIS_EMPLOYEE_IDS_QA } from '../cannabis';
import { NODE_ENV } from '../../../env';

export const initCannabisSchedule = (store, route, vm) => {
  if (!store) return;

  const tenantUrl = store.state.registration.tenantUrl || localStorage.tenantUrl;

  const { province } = store?.state?.registration?.patientData?.healthCard || {};
  if (!province) return;

  const employeeOptions = [];

  if (NODE_ENV === 'production' && tenantUrl === 'sentry-health') {
    // DR.VERNON = STEPH
    // DR.DONNA = RAMI

    const { DR_BHATTI, DR_GILLEN_RAMI, DR_GILLEN_STEPH } = CANNABIS_EMPLOYEE_IDS;
    if (province === 'quebec') employeeOptions.push(DR_GILLEN_STEPH);
    if (province !== 'quebec') employeeOptions.push(DR_GILLEN_RAMI);
    if (province === 'ontario') employeeOptions.push(DR_BHATTI);
    store.commit('setRegistration', {
      availableEmployees: employeeOptions,
    });

    if (province !== 'quebec') {
      vm.appointmentDuration = 15;
    } else {
      vm.appointmentDuration = 10;
    }
  } else if (NODE_ENV === 'qa' && tenantUrl === 'demo') {
    const { DR_BHATTI, DR_T_SAEED, DR_SAEED } = CANNABIS_EMPLOYEE_IDS_QA;
    if (province !== 'ontario') employeeOptions.push(DR_SAEED);
    if (province !== 'quebec') employeeOptions.push(DR_T_SAEED);
    if (province === 'ontario') employeeOptions.push(DR_BHATTI);
    store.commit('setRegistration', {
      availableEmployees: employeeOptions,
    });
  }

  if (NODE_ENV === 'development' && tenantUrl === 'demo') {
    store.commit('setRegistration', { appointmentSkills: [CANNABIS_SKILLS.DEV] });
  } else if (NODE_ENV === 'qa' && tenantUrl === 'demo') {
    store.commit('setRegistration', { appointmentSkills: [CANNABIS_SKILLS.QA] });
  } else if (NODE_ENV === 'production' && tenantUrl === 'sentry-health') {
    store.commit('setRegistration', { appointmentSkills: [CANNABIS_SKILLS.PROD] });
  }
};
